/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_FullInputs */

const en_scene_frontrow_full = /** @type {(inputs: Scene_Frontrow_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full`)
};

/**
* | output |
* | --- |
* | "Full" |
*
* @param {Scene_Frontrow_FullInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_full = /** @type {((inputs?: Scene_Frontrow_FullInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_FullInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_full(inputs)
});